export default "__VITE_ASSET__CGTJ1nxz__"